// api
import type {
  PostEnergyTreeNodeDto,
  SpecialNodeType,
} from '@/api/generated/recalc/endpoints/v2/energyGroups';

// relative
import type { AddNodeFormValues } from './addNodeForm.schema';

export function toAddNodeFormValues(): AddNodeFormValues {
  return {
    name: '',
    type: '',
    sourceType: 'dataStreams',
    dataStreams: [],
    options: {
      specialNodeType: null,
      consumption: null,
      percentage: null,
      openingHours: {},
      goShares: [],
    },
    locationId: null,
  };
}

export function toPostEnergyTreeNodeDto(
  values: AddNodeFormValues,
  parentId: string | null,
): PostEnergyTreeNodeDto {
  // When sourceType is 'dataStreams', use dataStreams
  // When sourceType is 'virtual', clear both dataStreams and residual fields
  // When sourceType is 'residual', clear dataStreams and set residual fields
  const dataStreams =
    values.sourceType === 'dataStreams' ? values.dataStreams : [];
  const specialNodeType =
    values.sourceType === 'residual'
      ? (values.options.specialNodeType as SpecialNodeType | null)
      : null;

  return {
    name: values.name?.trim() || null,
    type: values.type || null,
    parentId: parentId || null,
    // Backend requires empty array, not null - Python code iterates without null-check
    dataStreams: dataStreams,
    options: {
      specialNodeType: specialNodeType,
      consumption: values.options.consumption,
      percentage: values.options.percentage,
      openingHours: values.options.openingHours || null,
      goShares: values.options.goShares || null,
    },
    locationId: values.locationId,
  };
}
